import * as ActionTypes from './actionTypes.js';
import extend from 'lodash/extend';

export default function bobClientDetailsReducers(state = {}, action) {
    switch (action.type) {
        case ActionTypes.BOB_CLIENTS_DETAILS:
            return extend({}, state, action.payload);
        case ActionTypes.BOB_CLIENTS_DETAILS_FAILED:
            return extend({}, state, action.payload);
        case ActionTypes.BOB_CLIENTS_BILLING_DETAILS:
            return extend({}, state, action.payload);
        case ActionTypes.BOB_CLIENTS_BILLING_DETAILS_FAILED:
            return extend({}, state, action.payload);
        case ActionTypes.BOB_CLIENTS_COVERAGE_DETAILS:
            return extend({}, state, action.payload);
        case ActionTypes.BOB_CLIENTS_COVERAGE_DETAILS_FAILED:
            return extend({}, state, action.payload);
        case ActionTypes.BOB_CLIENTS_DEPENDENT_DETAILS:
            return extend({}, state, action.payload);
        case ActionTypes.BOB_CLIENTS_DEPENDENT_DETAILS_FAILED:
            return extend({}, state, action.payload);
        case ActionTypes.UPDATE_TAB_INDEX:
            return extend({}, state, action.payload);
        case ActionTypes.UPDATE_EMP_FILTER:
            return extend({}, state, action.payload);
        case ActionTypes.SET_CLIENT_USERAGENT_DETAILS:
        case ActionTypes.SET_CLIENT_USERAGENT_DETAILS_LOADING:
        case ActionTypes.CLIENT_USERAGENT_FETCH_FAILED:
            return extend({}, state, action.payload);
        default:
            return state;
    }
}
